import { AppState } from "app/shared/store/root.reducer";
import { createSelector } from "reselect";

// const getUserLogin = (state: AppState) => state.auth.userLogin;

const getAuth = (state: AppState) => state.auth.isAuth;

const getUserProfile = (state: AppState) => state.auth.userProfile;

export const getAuthSelector = createSelector(getAuth, (status) => status);
export const getUserProfileKeyCloakSelector = createSelector(getUserProfile, (info) => info);